export const EVENT_FREE_TEXT_QUESTION = 'EVENT_FREE_TEXT_QUESTION';

const handleAskAQuestion = (question) => {
  window.event.preventDefault();

  document.dispatchEvent(
    new CustomEvent(EVENT_FREE_TEXT_QUESTION, {
      detail: { entry: question },
    }),
  );

  return false;
};

const handleBotNav = (url, target) => {
  window.event.preventDefault();

  const win = window.open(url, target?.length === 0 ? '_self' : '_blank');

  if (target && target?.length !== 0) {
    win.focus();
  }

  return false;
};

export const setChatGlobals = () => {
  window.ask_question = handleAskAQuestion;
  window.bot_nav = handleBotNav;
  window.va = {
    ask: handleAskAQuestion,
  };
};
